import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import { CurrentUser, MemberLocale } from './interfaces';
import { IGetResourceResponse } from '@api/interfaces';

export const getCurrentMember = async (): Promise<CurrentUser> => {
  const response: AxiosResponse<IGetResourceResponse<CurrentUser>> =
    await apiClient.get('/me');

  return response.data.data;
};

export const updateMyLocale = async (
  locale: MemberLocale | null
): Promise<void> => {
  await apiClient.patch('/me/locale', { locale });
};
